import React, { useState } from 'react';
import { AssuranceIcon } from 'images';
import Modal from 'components/VideoModal';
import {
  StyledDiv,
  StyledOverLayDiv,
  StyledPlayButton,
  StyledIframe,
} from 'components/VimeoThumbnail/styles';
import { Box, CircularProgress } from '@material-ui/core';
import { getVideoUrl } from 'utils/vimeo';

const VimeoThumbnail = (props: {
  isLoadingThumbnail: boolean;
  vimeoThumbnailSrc: string;
  thumbnailErrorMessage: string;
  videoId: string;
  title: string;
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      {props.isLoadingThumbnail ? (
        <Box py={3.75} px={7.5}>
          <CircularProgress data-testid="loader" />
        </Box>
      ) : (
        <StyledDiv
          onClick={handleOpenModal}
          videoThumbnail={props.vimeoThumbnailSrc}
        >
          <StyledOverLayDiv />
          <StyledPlayButton
            src={AssuranceIcon['playButton']}
            alt="play-thumbnail"
          />
        </StyledDiv>
      )}
      {props.thumbnailErrorMessage && <h5>{props.thumbnailErrorMessage}</h5>}
      <Modal open={open} handleClose={handleCloseModal} title={props.title}>
        <StyledIframe
          title="vimeo-player"
          src={getVideoUrl(props.videoId)}
          frameBorder="0"
          allowFullScreen
        />
      </Modal>
    </>
  );
};

export default VimeoThumbnail;
